module.exports = __webpack_public_path__ + "images/emoji/mouse.617fdf7587fbcf4ee204.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mouse.png
// module id = s0j/
// module chunks = 14